import React, { Component } from "react"
import Helmet from "react-helmet"

import "./Page.scss"

// this comment exists purely to bust cache
const SITE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://ionq.com"

const defaultTitle = "IonQ"
const defaultDescription = `Working to build the world's best quantum computers to solve the world's most complex problems`
const defaultImage = `${SITE_URL}/images/ionq-og-2021-10-11.jpg`
const defaultTwitter = "@ionq_inc"
/*const defaultSep = ' | ';*/

class Page extends Component {
  getMetaTags(
    {
      title,
      description,
      image,
      contentType,
      twitter,
      twitterImage,
      noCrawl,
      published,
      updated,
      category,
      tags,
      canonical,
    },
    pathname
  ) {
    const theTitle = title
      ? title /* + defaultSep + defaultTitle*/
      : defaultTitle
    const theDescription = description
      ? description.substring(0, 155)
      : defaultDescription
    const theImage = image ? `${SITE_URL}${image}` : defaultImage
    const theTwitterImage = twitterImage
      ? `${SITE_URL}${twitterImage}`
      : defaultImage

    const metaTags = [
      { itemprop: "name", content: theTitle },
      { itemprop: "description", content: theDescription },
      { itemprop: "image", content: theImage },
      { name: "description", content: theDescription },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: defaultTwitter },
      { name: "twitter:title", content: theTitle },
      { name: "twitter:description", content: theDescription },
      { name: "twitter:creator", content: twitter || defaultTwitter },
      { name: "twitter:image:src", content: theTwitterImage },
      { property: "og:site_name", content: defaultTitle },
      {
        property: "facebook-domain-verification",
        content: "vm6macjl7iaw95ym4vmg678enq7sxi",
      },
      { property: "og:url", content: SITE_URL + pathname },
    ]

    if (
      new RegExp("/(news|posts|resources)/").test(
        this.props.location.pathname
      ) !== true
    ) {
      metaTags.push(
        { property: "og:type", content: contentType || "website" },
        { property: "og:title", name: "title", content: theTitle },
        { property: "og:image", name: "image", content: theImage },
        {
          property: "og:description",
          name: "description",
          content: description ? description : theDescription,
        }
      )
    }

    if (noCrawl) {
      metaTags.push({ name: "robots", content: "noindex, nofollow" })
    }

    if (published) {
      metaTags.push({ name: "article:published_time", content: published })
    }
    if (updated) {
      metaTags.push({ name: "article:modified_time", content: updated })
    }
    if (category) {
      metaTags.push({ name: "article:section", content: category })
    }
    if (tags) {
      metaTags.push({ name: "article:tag", content: tags })
    }

    return metaTags
  }

  render() {
    const { children, id, className, canonical, pathname, ...rest } = this.props

    return (
      <main id="main">
        <div id={id} className={className}>
          <Helmet
            prioritizeSeoTags
            htmlAttributes={{
              lang: "en",
              itemscope: undefined,
              itemtype: `http://schema.org/${rest.schema || "WebPage"}`,
            }}
            title={
              rest.title
                ? rest.title /* + defaultSep + defaultTitle */
                : defaultTitle
            }
            meta={this.getMetaTags(rest, this.props.location.pathname)}
          >
            <link
              rel="canonical"
              href={canonical ? SITE_URL + canonical : SITE_URL + pathname}
            />
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-DZJ2KYJQEB"></script>
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-DZJ2KYJQEB');
              `}
            </script>
          </Helmet>
          {children}
        </div>
      </main>
    )
  }
}

export default Page
